import { switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { getHousingUnitSummaryCard } from 'constants/routes'

/**
 * Retrieves an interactive site plan housing unit summary card..
 * @param {int} specId - The payload containing the spec id.
 * @returns {Observable} - An observable that emits the spec summary card information.
 */
const getHousingUnitSummaryCardInformation = (specId) => {
  const url = `${getHousingUnitSummaryCard}?id=${specId}`;
  
  return fromFetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  }).pipe(
    switchMap((response) => response.json())
  );
};

export default getHousingUnitSummaryCardInformation;